import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

export const DATE_FORMAT = 'YYYY-MM-DD';

export const formatDate = (
  date: string,
  format: string = DATE_FORMAT,
): string => {
  return dayjs(date).format(format);
};

const localeMap: {[key: string]: string} = {
  en: 'en-gb',
  es: 'es',
  fr: 'fr',
  de: 'de',
  nl: 'nl',
  it: 'it',
  lt: 'lt',
  pt: 'pt',
  el: 'el',
};

export const getDayjsLocale = (locale: string) => {
  const localePrefix = locale.split('_');
  const localePrefixLowerCase =
    localePrefix[0] && localePrefix[0].toLowerCase();
  if (!localePrefixLowerCase) {
    return undefined;
  }
  return localeMap[localePrefixLowerCase];
};

export const fetchDateLocale = async (locale: string): Promise<void> => {
  const daysjsLocale = getDayjsLocale(locale);

  try {
    await import(
      /* webpackChunkName: "dayjs-locales-[request]" */ `dayjs/locale/${daysjsLocale}.js`
    );
    dayjs.locale(daysjsLocale);
  } catch (e) {
    dayjs.locale('en-gb');
  }
};
